export default __webpack_public_path__ + "static/media/IMG_4528-min.028b1ec8.JPG";